import React, { Component, Fragment } from 'react';
import { submit, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import 'react-table/react-table.css';

import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import AddPromotionForm from './addPromotionForm';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import {
  getPromotions,
  getProperties,
  createOrUpdatePromotion,
  deletePromotion,
} from 'actions/landlordPropertiesActions';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from '@material-ui/core/Button';
import { localize } from 'react-localize-redux';

const LandlordPromotions = withMobileDialog()(
  connect(
    store => ({
      properties: store.landlordProperties.properties,
      promotions: store.landlordProperties.promotions,
    }),
    {
      getProperties,
      createOrUpdatePromotion,
      getPromotions,
      deletePromotion,
      submit,
    }
  )(
    class LandlordPromotions extends Component {
      state = {
        promotionIsOpen: false,
        disabledSubmit: false,
        showConfirmation: false,
      };

      componentDidMount() {
        this.props.getProperties({ for_multiselect: true });
        this.props.getPromotions();
      }

      submitForm = formData => {
        if (!formData['properties'] || formData['properties'].length === 0) {
          throw new SubmissionError({
            properties: 'Required',
          });
        }

        this.setState({ disabledSubmit: true });
        const promotionId = this.props.promotionDetails ? this.props.promotionDetails.id : null;
        this.props.createOrUpdatePromotion(promotionId, formData).then(() => {
          this.props.togglePromotionDialog();
          this.setState({ disabledSubmit: false });
        });
      };

      deletePromotion = () => {
        this.props.deletePromotion(this.props.promotionDetails.id).then(() => {
          this.props.togglePromotionDialog();
          this.setState({ showConfirmation: false });
          this.props.getPromotions();
        });
      };

      showConfirmationDialog = () => {
        this.setState({
          showConfirmation: !this.state.showConfirmation,
        });
      };

      render() {
        const { fullScreen, translate } = this.props;
        return (
          <Fragment>
            <Dialog
              disableBackdropClick
              fullScreen={fullScreen}
              open={this.props.promotionIsOpen}
              onClose={this.props.togglePromotionDialog}
              aria-labelledby="add-new-promotion"
              classes={{
                paper: 'form-dialog',
              }}
            >
              <DialogTitle id="add-new-promotion">
                <h3 style={{ textAlign: 'center', margin: 0 }}>
                  {this.props.promotionDetails
                    ? translate('landlordPortal.promotions.promotionDetailsTitle')
                    : translate('landlordPortal.promotions.addNewPromotion')}
                </h3>
              </DialogTitle>
              <DialogContent>
                <AddPromotionForm
                  onSubmit={this.submitForm}
                  properties={this.props.properties}
                  initialValues={this.props.promotionDetails || { properties: [] }}
                />
              </DialogContent>
              <DialogActions style={{ display: 'block' }}>
                <FlatButton
                  onClick={this.props.togglePromotionDialog}
                  id="close-button"
                  style={{ color: AccentColor() }}
                >
                  {translate('landlordPortal.promotions.cancel')}
                </FlatButton>
                {this.props.promotionDetails && (
                  <FlatButton
                    onClick={this.showConfirmationDialog}
                    id="close-button"
                    style={{ color: AccentColor() }}
                  >
                    {translate('landlordPortal.promotions.deleteUpcase')}
                  </FlatButton>
                )}
                <FlatButton
                  variant="raised"
                  onClick={() => this.props.submit('add_promotion_form')}
                  disabled={this.state.disabledSubmit}
                  id="submit-button"
                  style={{
                    color: 'white',
                    backgroundColor: this.state.disabledSubmit ? colors.LIGHT_GRAY : AccentColor(),
                  }}
                >
                  {translate('landlordPortal.promotions.save')}
                </FlatButton>
              </DialogActions>
            </Dialog>
            <ConfirmationDialog
              showDialog={this.state.showConfirmation}
              hideDialog={this.showConfirmationDialog}
              userConfirmVerbiage={translate('landlordPortal.promotions.delete')}
              userConfirmAction={this.deletePromotion}
              dialogTitle={translate('landlordPortal.promotions.areYouSure')}
              dialogBodyVerbiage={translate('landlordPortal.promotions.areYouSureYouWant')}
            />
          </Fragment>
        );
      }
    }
  )
);

export default localize()(LandlordPromotions);
